import { ThemeOptions } from "@material-ui/core/styles";
import createBreakpoints from '@material-ui/core/styles/createBreakpoints'

const breakpoints = createBreakpoints({})

export const r2PaletteColors = {
    orange: '#D26D13',
    green: '#219653',
    black: '#393B40',
    red: '#DB4E4E',
    blue: '#2C9AFF',
    purple: '#9800ff',
    yellow: '#ffea00',
    brown: '#b23c17',
}

export const darkTheme = {
    palette: {
        primary: {
            main: '#2c9aff',
        },
        secondary: {
            main: '#FFD2AA',
        },
        type: 'dark' as 'dark', // Switching the dark mode on is a single property value change.
    },
    shape: {
        borderRadius: 10,
    },
    overrides: {
        MuiCssBaseline: {
            "@global": {
                body: {
                    scrollbarColor: "#6d6d6d #303030",
                    "&::-webkit-scrollbar, & *::-webkit-scrollbar": {
                        backgroundColor: "#303030",
                    },
                    "&::-webkit-scrollbar-thumb, & *::-webkit-scrollbar-thumb": {
                        borderRadius: 8,
                        backgroundColor: "#6d6d6d",
                        minHeight: 24,
                        border: "3px solid #303030",
                    },
                    "&::-webkit-scrollbar-thumb:focus, & *::-webkit-scrollbar-thumb:focus": {
                        backgroundColor: "#6d6d6d",
                    },
                    "&::-webkit-scrollbar-thumb:active, & *::-webkit-scrollbar-thumb:active": {
                        backgroundColor: "#6d6d6d",
                    },
                    "&::-webkit-scrollbar-thumb:hover, & *::-webkit-scrollbar-thumb:hover": {
                        backgroundColor: "#6d6d6d",
                    },
                    "&::-webkit-scrollbar-corner, & *::-webkit-scrollbar-corner": {
                        backgroundColor: "#303030",
                    },
                },
            },
        },
        MuiAppBar: {
            colorSecondary: {
                color: '#ffffff',
                backgroundColor: '#303030',
            },
            root: {
                boxShadow: 'none',
            }
        },
        RaMenuItemLink: {
            root: {
            },
            active: {
                borderLeft: '3px solid #2c9aff',
            },
        },
        MuiButtonBase: {
            root: {
                '&:hover:active::after': {
                    // recreate a static ripple color
                    // use the currentColor to make it work both for outlined and contained buttons
                    // but to dim the background without dimming the text,
                    // put another element on top with a limited opacity
                    content: '""',
                    display: 'block',
                    width: '100%',
                    height: '100%',
                    position: 'absolute',
                    top: 0,
                    right: 0,
                    backgroundColor: 'currentColor',
                    opacity: 0.3,
                    borderRadius: 'inherit',
                },
            },
        },
        MuiMenuItem: {
            root: {
                textTransform: 'uppercase',
                fontWeight: 'bold',
                fontSize: '0.75rem',
                borderBottom: 'none',
            }
        },
        MuiTableCell: {
            root: {
                borderBottom: '1px solid #868B96'
            },
            head: {
                textTransform: 'uppercase',
                fontWeight: 'bold',
                fontSize: '0.7rem',
                borderBottom: 'none',
            }
        },
        RaDatagrid: {
            headerCell: {
                backgroundColor: '#303030',
            }
        },
        RaSidebar: {
            fixed: {
                position: 'static' //TODO: background fix
            }
        },
        MuiPaper: {
            root: {
                border: 'none',
                backgroundClip: 'padding-box',
                // backgroundColor: 'transparent',
            },
        },
    },
    props: {
        MuiButtonBase: {
            // disable ripple for perf reasons
            disableRipple: true,
        },
    },
};

export const lightTheme: ThemeOptions | { [key: string]: any } = {
    typography: {
        fontFamily: [
            '"Avenir Next LT Pro"',
            // '"Lato"',
            'sans-serif',
        ].join(', '),
        h1: {
            fontWeight: 600,
        },
        h2: {
            fontWeight: 600,
        },
        h3: {
            fontWeight: 600,
        },
        h4: {
            fontWeight: 600,
        },
        h5: {
            fontWeight: 600,
        },
        h6: {
            fontWeight: 600,
        },
        button: {
            fontWeight: 600,
        }
    },
    palette: {
        primary: {
            main: '#2c9aff',
            dark: '#BFC5D3',
        },
        secondary: {
            light: '#0C101B',
            main: '#0b6eca',
            dark: '#491019',
            contrastText: '#fff',
        },
        background: {
            default: '#EEEFF0',
        },
        type: 'light' as 'light',
    },
    shape: {
        borderRadius: 10,
    },
    overrides: {
        MuiCssBaseline: {
            "@global": {
                body: {
                    scrollbarColor: "#6d6d6d #EEEFF0",
                    "&::-webkit-scrollbar, & *::-webkit-scrollbar": {
                        backgroundColor: "#EEEFF0",
                    },
                    "&::-webkit-scrollbar-thumb, & *::-webkit-scrollbar-thumb": {
                        borderRadius: 8,
                        backgroundColor: "#6d6d6d",
                        minHeight: 24,
                        border: "3px solid #EEEFF0",
                    },
                    "&::-webkit-scrollbar-thumb:focus, & *::-webkit-scrollbar-thumb:focus": {
                        backgroundColor: "#6d6d6d",
                    },
                    "&::-webkit-scrollbar-thumb:active, & *::-webkit-scrollbar-thumb:active": {
                        backgroundColor: "#6d6d6d",
                    },
                    "&::-webkit-scrollbar-thumb:hover, & *::-webkit-scrollbar-thumb:hover": {
                        backgroundColor: "#6d6d6d",
                    },
                    "&::-webkit-scrollbar-corner, & *::-webkit-scrollbar-corner": {
                        backgroundColor: "#EEEFF0",
                    },
                },
            },
        },
        RaListToolbar: {
            toolbar: {
                [breakpoints.down('sm')]: {
                    backgroundColor: 'transparent'
                }
            },
        },
        RaMenuItemLink: {
            root: {
                borderLeft: '3px solid #fff',
            },
            active: {
                borderLeft: '3px solid #2c9aff',
            },
        },
        RaDatagrid: {
            headerCell: {
                backgroundColor: '#EEEFF0',
            }
        },
        RaSidebar: {
            fixed: {
                position: 'static' //TODO: background fix
            }
        },
        RaUserMenu: {
            user: {
                border: '2px solid #BFC5D3',
                borderRadius: '10px',
                margin: '0.3em 0',
            }
        },
        RaReferenceField: {
            link: {
                fontWeight: 600,
            }
        },
        // RaFilterButton: {
        //     root: {
        //         backgroundColor: '#555'
        //     }
        // },
        MuiPaper: {
            elevation1: {
                boxShadow: '0 1px 2px 0 rgba(0,0,0,0.05)',
            },
            root: {
                // border: '1px solid #EEEFF0',
                border: 'none',
                backgroundClip: 'padding-box',
                // backgroundColor: 'transparent',
            },
        },
        MuiBadge: {
            colorPrimary: {
                color: '#FFF',
            }
        },
        MuiFormLabel: {
            root: {
                fontSize: '0.9rem',
                textTransform: 'uppercase',
                fontWeight: 'bold',
            }
        },
        MuiButton: {
            contained: {
                backgroundColor: '#fff',
                color: '#000',
                boxShadow: 'none',
                textTransform: 'uppercase',
                fontWeight: 'bold',
                borderBottom: 'none',
            },
            containedSizeSmall: {
                fontSize: '0.75rem',
            }
        },
        MuiChip: {
            label: {
                fontWeight: 500,
            }
        },
        MuiButtonBase: {
            root: {
                '&:hover:active::after': {
                    // recreate a static ripple color
                    // use the currentColor to make it work both for outlined and contained buttons
                    // but to dim the background without dimming the text,
                    // put another element on top with a limited opacity
                    content: '""',
                    display: 'block',
                    width: '100%',
                    height: '100%',
                    position: 'absolute',
                    top: 0,
                    right: 0,
                    backgroundColor: 'currentColor',
                    opacity: 0.3,
                    borderRadius: 'inherit',
                },
            },
        },
        MuiAppBar: {
            colorSecondary: {
                color: '#000',
                backgroundColor: '#EEEFF0',
            },
            root: {
                boxShadow: 'none',
            }
        },
        MuiTableCell: {
            root: {
                borderBottom: '1px solid #868B96'
            },
            head: {
                textTransform: 'uppercase',
                fontWeight: 'bold',
                fontSize: '0.7rem',
                borderBottom: 'none',
            }
        },
        MuiMenuItem: {
            root: {
                textTransform: 'uppercase',
                fontWeight: 'bold',
                fontSize: '0.75rem',
                borderBottom: 'none',
            }
        },
        MuiCheckbox: {
            root: {
                color: '#868B96',
                borderRadius: '4px',
            }
        },
        MuiTableSortLabel: {
            active: {
                color: '#000'
            }
        },
        MuiLinearProgress: {
            colorPrimary: {
                backgroundColor: '#2c9aff',
            },
            barColorPrimary: {
                backgroundColor: '#2c9aff',
            },
        },
        MuiFilledInput: {
            root: {
                backgroundColor: 'rgba(0, 0, 0, 0.04)',
                '&$disabled': {
                    backgroundColor: 'rgba(0, 0, 0, 0.04)',
                },
            },
        },
        MuiSnackbarContent: {
            root: {
                border: 'none',
            },
        },
    },
    props: {
        MuiButtonBase: {
            // disable ripple for perf reasons
            disableRipple: true,
        },
    },
}
